<template>
	<div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
			<!-- 按钮 -->
			<list-btn
			:listArr="listArr"
			:sdata="sdata"
			@detail="detail"
			@edit="edit"
			@add="add"
			@del="del"
			@restore="restore"
			isAdd
			isEdit
      isDelStatus
			></list-btn>

      <tab-list
      :tabList="listArr"
      :total="total"
      :pages="pages"
      :fromData="fromData"
      :columns="tabColumns"
      tabName="base-fstock"
      @currentChange="currentChange"
      @changePages="changePages"
      @selectSdata="selectSdata"
      @dbClick="dbClick">
      </tab-list>

      <!-- 详情 -->
      <el-dialog title="库存地点详情"
      :visible.sync="dialogFormVisible"
      customClass="dialog_detail_style"
      v-dialogDrag @closed="closedDialog" >
        <detail :sdata="sdata" class="contnet_box"></detail>
      </el-dialog>



	</div>
</template>

<script>
import {fstockApi} from 'api/base.js'

import listBtn from 'components/btn/listBtn.vue'
import tabList  from 'components/table/list.vue';
import searchBox from './components/list/search.vue';
import detail from './detail.vue';
export default{
	components:{
		listBtn,
		tabList,
    searchBox,
    detail
	},
	data() {
		return {
      dialogFormVisible:false,
			isComponentChild:false,
			isDelList:false,//是否显示已删除的
			sdata:{},
			listArr:[],//列表
			tabColumns:[
        {field: 'inventoryCode', title: '库存地编码',need:true, width:120,"sortable":true},
        {field: 'inventoryDesc', title: '库存地点描述',need:true},
			  {field: 'factoryCode', title: '工厂编码'},
			  {field: 'factoryDesc', title: '工厂描述'},
			  {field: 'maintainStatus', title: '状态',
			  formatter: function (rowData,rowIndex,pagingIndex,field) {
			    return rowData.maintainStatus === 'X' ? "已删除" : "正常";
			  }
			  }
			],//表头字段
			maintainStatus:[
        {text:'正常',value:''},
        {text:"已删除",value:"X"}
			],
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:20,//每页显示的数量,
				searchCriteria:{//查询的附加条件
				}
			}
		}
	},
	created(){
		this.getListArr();
	},
	methods:{
    //双击
    dbClick(data){
      this.sdata = data;
      this.detail();
    },
    //选中数据
    selectSdata(data){
      this.sdata = data;
      console.log(this.sdata)
    },
    //当前页码改变
    currentChange(currentPage){
      this.fromData.page = currentPage;
      this.getListArr();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getListArr();
    },
		//获取初始数据
		async getListArr(){
      console.log(this.fromData,'== 请求的数据 ==');
			let res = await this.$post(fstockApi.list,this.fromData);
      if(res.status && res.data){
        console.log(res.data.list)
        if(res.data.list){
        	res.data.list.forEach((item,index)=>{
        		if(item.maintainStatus === 'X'){
        			item.isDel = true;
        		}else{
        			item.isDel = false;
        		}
        		item.isChecked = false;
        	});
        }
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      }else{
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
		},
    subSearch(){
      this.getListArr()
    },
		handleSelectChange(item,key){
			if(item.isChecked){
				item.isChecked = false;
				this.sdata = {};
			}else{
				this.sdata = item;
				this.sdata.index = key;
				item.isChecked = true;
				this.listArr.forEach((items)=>{
					if(items.inventoryId != item.inventoryId){
						items.isChecked = false;
					}
				});
				if(item.maintainStatus === 'X'){
					this.sdata.isDel = true;
				}else{
					this.sdata.isDel = false;
				}
			}
		},
		//选择的改变
		changeSelect(val,item,key){
			this.handleSelectChange(item,key);
		},
		//详情
		detail(){
			if(!this.sdata.inventoryId){
				this.$message.error('请选择要查看的记录');
				return;
			}
      this.dialogFormVisible = true;
			//this.$router.push({name:'base-fstock-detail',params:{id:this.sdata.inventoryId}});
		},
    //关闭弹出层
    closedDialog(){
      this.dialogFormVisible = false;
    },
		//新增
		add(){
			this.$router.push({name: 'base-fstock-add'});
		},
		//编辑
		edit(){
			if(!this.sdata.inventoryId){
				this.$message.error('请选择要编辑的记录');
				return;
      }
      if(this.sdata.maintainStatus === 'X'){
        this.$message.error('该条记录已删除，不允许编辑！');
				return;
      }
			this.$router.push({name: 'base-fstock-edit', params: {id:this.sdata.inventoryId}});
		},

    //删除
    del(){
      let vm = this;
      if(!this.sdata.inventoryId){
        this.$message.error('请选择需要删除的记录');
        return;
      }
      this.$confirm('确定删除这条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeDataStatus(fstockApi.del,"删除成功！","X");
      }).catch(() => {});
    },
    //恢复删除
    restore(){
      let vm = this;
      if(!this.sdata.inventoryId){
        this.$message.error('请选择需要恢复的记录');
        return;
      }
      this.$confirm('恢复此记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          this.changeDataStatus(fstockApi.restore,"修改成功！","");
      });
    },
    /**
     * [ 改变物料状态 ]
     * @param {Object} api 调用的接口
     * @param {Object} message 操作成功后，提示的消息
     * @param {Object} status  操作成功后，状态
     */
    async changeDataStatus(api,message,status){
      this.$store.state.loadingTxt = "处理中...";
      this.$store.state.isLoading = true;
      let res = await this.$get(api,{inventoryId:this.sdata.inventoryId});
      this.$store.state.isLoading = false;
      if(res.status){
        this.$message.success("库存地点"+this.sdata.inventoryCode+message);
        this.$set(this.sdata,'maintainStatus',status);
      }else{
        this.$message.error(res.msg);
        this.sdata.isDel = false;
      }
    }
	}
}
</script>

<style>
</style>
